import React, { createContext, useState, useMemo, useCallback } from "react";

export const AIHelperContext = createContext({
    task: "",                 // 👈 здесь лежит задание (prompt) для OpenRouter
    setTask: () => {},        // установщик задания
    mode: "writer",           // "writer" | "translator"
    setMode: () => {},
    model: "openai/gpt-4o-mini-2024-07-18",
    temperature: 0.7,
    setModel: () => {},
    setTemperature: () => {},
});

export const AIHelperProvider = ({ children, initialMode = "writer" }) => {
    const [task, setTask] = useState("");
    const [mode, setMode] = useState(initialMode);
    const [model, setModel] = useState("openai/gpt-4o-mini-2024-07-18");
    const [temperature, setTemperature] = useState(0.7);

    const value = useMemo(
        () => ({
            task,
            setTask,
            mode,
            setMode,
            model,
            setModel,
            temperature,
            setTemperature,
        }),
        [task, mode, model, temperature]
    );

    return <AIHelperContext.Provider value={value}>{children}</AIHelperContext.Provider>;
};
